module.exports = __webpack_public_path__ + "img/walks_thumb.dfed92b6.jpg";